// extracted by mini-css-extract-plugin
export var articlePreview = "articlePreview-module--article-preview--NS0ot";
export var author = "articlePreview-module--author--jpiFz";
export var authorSection = "articlePreview-module--author-section--W456o";
export var descriptionSection = "articlePreview-module--description-section--O-ee5";
export var dot = "articlePreview-module--dot--jtaR3";
export var imageLink = "articlePreview-module--image-link--bhvLA";
export var infoSection = "articlePreview-module--info-section--hseUh";
export var rowSection = "articlePreview-module--row-section--vAl-v";
export var typeSection = "articlePreview-module--typeSection--iBdJG";